export class React {
    flag = 1;

    constructor(state, on_state_changed = null) {
        this.handlers = new Map();
        this.origin_state = state;
        this.origin_state.counter = 0;
        this.prev_state = {...state};
        this.first_updated = true;

        if (on_state_changed) {
            this.handlers.set('state-changed', on_state_changed);
        }

        this.react_state = (() => {
            let $this = this;

            return new Proxy(state, {
                get(state, prop) {
                    return state[prop];
                },

                set(state, prop, new_value) {
                    let current_state = {...state};
                    let old_value = state[prop];
                    let handler_state_changed = $this.handlers.get('state-changed')

                    if (old_value == new_value) return true;

                    state[prop] = new_value;

                    if (state.counter == $this.prev_state.counter) {
                        if (handler_state_changed) {
                            handler_state_changed(prop, {...state}, $this.prev_state);
                        }

                        let handler = $this.handlers.get(prop);

                        if (handler) {
                            handler(new_value, old_value);
                        }
                    } else {
                        if (handler_state_changed) {
                            handler_state_changed(prop, current_state, $this.prev_state);
                        }

                        Object.keys(current_state).forEach(prop => {
                            if (current_state[prop] != $this.prev_state[prop]) {
                                let handler =  $this.handlers.get(prop);
                                
                                if (handler) {
                                    handler(current_state[prop], $this.prev_state[prop]);
                                }   
                            }
                        })
                    }

                    if ($this.first_updated) {
                        $this.first_updated = false;
                    }

                    $this.flag = 1;
                    return true;
                }
            })
        }).apply(this)
    }

    on(prop, cb) {
        this.handlers.set(prop, cb);
    }

    off(prop) {
        this.handlers.delete(prop);  
    }

    set(prop, value, trigger = true) {
        if (this.flag == 1) {
            this.prev_state = {...this.origin_state};
            this.flag = 0;
        }

        if (trigger) {
            this.prev_state = {...this.origin_state};
            this.react_state[prop] = value;
        } else {
            this.origin_state[prop] = value;
        }
    }

    get(prop) {
        return this.origin_state[prop]
    }

    update() {
        this.react_state['counter'] = this.react_state['counter'] + 1;
        this.flag = 1;
    }
}